import { render, staticRenderFns } from "./MonitorScoreExamAdd.vue?vue&type=template&id=95f84702&"
import script from "./MonitorScoreExamAdd.vue?vue&type=script&lang=js&"
export * from "./MonitorScoreExamAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports